<template>
    <div>
        <v-overlay :value="loading" absolute>
            <v-progress-circular indeterminate size="64" color="primary" />
        </v-overlay>
        <div v-if="!loading">
            <app-form
                v-bind:parentObject="{
                    data: this.formData,
                    pageTitle: this.pageTitle,
                    pageTitleValue: this.pageTitleValue,
                    errMsg: this.errMsg,
                    isEdit: this.editMode,
                }"
                v-on:input="formData = $event"
                v-on:save="saveHandler"
                v-on:error="errorHandler"
            />

            <div v-if="isErr">
                <app-error
                v-bind:parentError="{
                    data: this.errMsg,
                    isErr: this.isErr,
                }"
                v-on:closeError="isErr = $event"
                />
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';

import RoleAssignmentForm from "../../../components/settings/roleassignment/Form.vue";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
    components: {
        "app-form": RoleAssignmentForm,
        "app-error": ErrorDialog,
    },

    data() {
        return {
            id: this.$route.params.id,
            pageTitle: this.$t('roleassignment.editroleassignment'),
            pageTitleValue: "",
            formData: {},
            errMsg: "",
            isErr: false,
            loading: true,
            editMode: false,
            isConfirm: false,
        };
    },

    methods: {
        errorHandler($event) {
            this.isErr = $event.isErr;
            this.errMsg = $event.errMsg;
        },

        saveHandler() {
            
            const vm = this;

            if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
                return false;
            }

            this.formData.userid = vm.$store.getters.userId;

            this.$store.dispatch('put', {url: "/roleassignment/" + vm.id, payload: vm.formData})
            .then((res) => {
                if (res.data.error) {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = res.data.error;
                } else {
                    vm.$router.push({ name: "roleassignmentlist" });
                }
            })
            .catch((err) => {
                vm.isErr = !vm.isErr;
                vm.errMsg = err;
            });

        },

        loadRoleAssignmentHandler() {

            const vm = this;

            return this.$store.dispatch('get', {url: "/roleassignment/" + vm.id})
            .then((res) => {

            if (res.status == 200) {
                
                vm.formData = res.data.rec[0];

                vm.pageTitleValue = `${vm.formData.rolecode} - ${vm.formData.staffno}`;

                if (vm.formData.startdate) {
                    vm.formData.startdate = moment(vm.formData.startdate).format('YYYY-MM-DD');
                }

                if (vm.formData.enddate) {
                    vm.formData.enddate = moment(vm.formData.enddate).format('YYYY-MM-DD');
                }

                vm.loading = !vm.loading;

            } else {
                vm.isErr = !vm.isErr;
            }
            })
            .catch((err) => {
                console.log(err);
                vm.isErr = !vm.isErr;
                vm.errMsg = err;
            });
        },

    },

    async mounted() {
        await this.loadRoleAssignmentHandler();
    },
};
</script>